const SEARCH_TYPE_PAGE = 'page';
const SEARCH_PRE_PAGE = 9;

document.addEventListener('DOMContentLoaded', function () {
  const boot = window.__RO_SEARCH_PAGES_BOOTSTRAP__;
  if (!boot || !Array.isArray(boot.searchResults)) return;

  const searchResults = boot.searchResults;
  const searchCurrentPage = parseInt(
    new URLSearchParams(window.location.search).get('currentPage') || '1',
    10
  ) || 1;
  const total = searchResults.length;
  const totalPages = Math.max(Math.ceil(total / SEARCH_PRE_PAGE), 1);
  const currentPage = Math.min(searchCurrentPage, totalPages);

  initSearchInputEvent(boot);

  renderNoDataState(total === 0);
  if (total === 0) return;

  setPageResultCount(total);
  renderPageCards(boot, searchResults, currentPage);
  renderPaginationor(currentPage, totalPages);
  setPaginationorEvent(currentPage, totalPages);

  function toDescriptionLines(text) {
    if (!text) return [];
    const byNl = text.split(/\n+/).map((s) => s.trim()).filter(Boolean);
    if (byNl.length > 1) return byNl.slice(0, 5);
    const parts = text.split(/[.!?]\s+/).map((s) => s.trim()).filter(Boolean);
    return parts.length ? parts.slice(0, 5) : [text];
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderPageCards(bootCfg, list, page) {
    const templateEl = document.getElementById('search-page-card-template');
    const container = document.querySelector('[data-search-page-card-container]');
    if (!templateEl || !container) return;

    const templateHTML = templateEl.innerHTML.trim();
    const start = (Math.max(page, 1) - 1) * SEARCH_PRE_PAGE;
    const pageItems = list.slice(start, start + SEARCH_PRE_PAGE);

    const html = pageItems
      .map(function (item) {
        let inline = '';
        let linesHtml = '';
        const rich = item.summary_html && String(item.summary_html).trim();
        if (rich) {
          linesHtml = '<div class="ro-search-page-card__richtext">' + item.summary_html + '</div>';
        } else {
          const lines = toDescriptionLines(item.summary_plain || '');
          inline = lines.length ? lines.map(escapeHtml).join(' 丨 ') : '';
          linesHtml = lines.map((l) => '<p>' + escapeHtml(l) + '</p>').join('');
        }
        const imgSrc =
          item.image_url && String(item.image_url).indexOf('//') === 0
            ? 'https:' + item.image_url
            : item.image_url || '';
        const imgHtml = imgSrc
          ? '<img src="' +
            escapeHtml(imgSrc) +
            '" alt="' +
            escapeHtml(item.title || '') +
            '" loading="lazy" width="100" height="100" />'
          : '';
        const extraCardClass = rich ? ' ro-search-page-card--has-richtext' : '';
        return templateHTML
          .replace('[[page_card_extra_class]]', extraCardClass)
          .replace('[[page_image_html]]', imgHtml)
          .replaceAll('[[page_title]]', escapeHtml(item.title || ''))
          .replace('[[page_desc_inline]]', inline)
          .replace('[[page_desc_lines]]', linesHtml)
          .replaceAll('[[page_url]]', item.url || '#')
          .replaceAll('[[learn_more]]', bootCfg.learnMoreLabel || 'Learn More');
      })
      .join('');
    container.innerHTML = html;

    document.dispatchEvent(
      new CustomEvent('ro-search:pages-rendered', {
        detail: {
          pageItems: pageItems,
          container: container,
        },
      })
    );
  }

  function setPageResultCount(count) {
    const el = document.getElementById('PageResultsCount');
    if (el) el.textContent = String(count);
  }

  function renderNoDataState(isEmpty) {
    const block = document.getElementById('SearchResultBlock');
    if (!block) return;
    if (isEmpty) block.classList.add('no-data');
    else block.classList.remove('no-data');
  }

  function renderPaginationor(currentPageNum, totalPagesNum) {
    if (totalPagesNum < 1) return;
    const templateEl = document.getElementById('search-paginationor-template');
    const container = document.querySelector('[data-search-paginationor-pages]');
    if (!templateEl || !container) return;

    const templateHTML = templateEl.innerHTML.trim();
    const html = templateHTML
      .replace('[[prev_disabled]]', currentPageNum <= 1 ? 'disabled' : '')
      .replace('[[next_disabled]]', currentPageNum >= totalPagesNum ? 'disabled' : '')
      .replaceAll('[[currentPage]]', currentPageNum)
      .replaceAll('[[totalPages]]', totalPagesNum);
    container.innerHTML = html;
  }

  function setPaginationorEvent(currentPageNum, totalPagesNum) {
    const paginationor = document.querySelector('[data-search-paginationor-pages]');
    if (!paginationor) return;

    paginationor.addEventListener('click', handlePaginationBtn);
    const stepInput = paginationor.querySelector('#PaginationStep');
    if (stepInput) {
      stepInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitPageInput(e);
        }
      });
      stepInput.addEventListener('blur', submitPageInput);
    }

    function handlePaginationBtn(event) {
      const t = event.target.dataset.type || '';
      if (!t || event.target.disabled) return;
      let newPage = 1;
      if (t === 'next') {
        newPage = Math.min(currentPageNum + 1, totalPagesNum);
      } else if (t === 'prev') {
        newPage = Math.max(currentPageNum - 1, 1);
      }
      if (newPage === currentPageNum) return;
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.delete('currentPage');
      if (newPage > 1) params.set('currentPage', newPage);
      reloadUrl(url, params);
    }

    function submitPageInput(event) {
      const raw = event.target.value;
      let newValue = parseInt(raw, 10);
      if (Number.isNaN(newValue)) return;
      if (newValue < 1) newValue = 1;
      if (newValue > totalPagesNum) newValue = totalPagesNum;
      if (newValue === currentPageNum) return;
      if (stepInput) stepInput.value = String(newValue);
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.delete('currentPage');
      if (newValue > 1) params.set('currentPage', newValue);
      reloadUrl(url, params);
    }
  }

  function initSearchInputEvent(bootCfg) {
    const inputId = 'search-result-input-' + bootCfg.sectionId;
    const searchInput = document.getElementById(inputId);
    if (!searchInput) return;

    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        const term = searchInput.value.trim();
        const params = new URLSearchParams(window.location.search);
        if (params.get('q') === term) return;

        const url = new URL(window.location.href);
        const paramsNew = url.searchParams;
        paramsNew.delete('currentType');
        paramsNew.delete('currentPage');
        paramsNew.set('q', term);
        reloadUrl(url, paramsNew);
      }
    });
  }

  function reloadUrl(url, params) {
    params.set('type', SEARCH_TYPE_PAGE);
    url.search = params.toString();
    window.location.href = url.toString();
  }
});
